module.exports = __webpack_public_path__ + "static/media/Rysunek5.ba79aa1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/architektura/Rysunek5.jpg
// module id = 558
// module chunks = 0